import { queryClient, useMutation } from 'query';
import { manageEventInvitee } from '../../services';
import type { EmailSelectedUserWithRole, RegisteredSelectedUserWithRole } from '../../types';
import { getEventDetailQueryKey, getEventsInviteesInfiniteQueryKey, getEventsQueryKey } from '../keys';

export const useUpdateEventInviteeRoleMutation = () =>
  useMutation<
    unknown,
    {
      emailInvitees?: EmailSelectedUserWithRole[];
      eventId: string;
      invitees?: RegisteredSelectedUserWithRole[];
    }
  >({
    async mutationFn({ emailInvitees, eventId, invitees }) {
      await manageEventInvitee({
        body: {
          event: {
            email_invitees: emailInvitees?.map(({ email, eventRole }) => ({ email, event_role: eventRole })),
            invitees: invitees?.map(({ eventRole, id }) => ({ event_role: eventRole, id })),
          },
        },
        routeParams: { id: eventId },
      });
    },
    async onSuccess(_, { eventId }) {
      // TODO: change cache
      await queryClient.invalidateQueries({ queryKey: getEventsInviteesInfiniteQueryKey({ filter: { eventId } }) });
      await queryClient.invalidateQueries({ queryKey: getEventDetailQueryKey({ id: eventId }) });
      await queryClient.invalidateQueries({ queryKey: getEventsQueryKey({}) });
    },
  });
